import ModalForm from 'components/commons/modal-form'
import UploadImage from 'components/commons/upload-image'
import icImageDefault from 'assets/images/ic-image-x.svg'
import { InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'

export const FormCategory = ({
    show,
    onHideForm,
    dataCategory,
    options,
    onSearchOptions,
    isLoading,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={`${!dataCategory?.id ? 'Create' : 'Update'} Category`}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <UploadImage
                    classNameImage={'!w-28 !h-28 border border-neutral-30'}
                    classNameButtonDelete={'!-top-2 !-right-2'}
                    id={'thumbnail'}
                    caption={'Thumbnail'}
                    value={dataCategory?.image_url?.base64 || dataCategory?.image_url || icImageDefault}
                    onChange={(value) => onChangeForm({ name: 'image_url', value })}
                />
                <InlineError className='mt-2 self-center' message={errorForm?.image_url} />
                {(dataCategory?.parent || !dataCategory?.id) && (
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Parent Category</div>
                        <Select
                            name={'parent'}
                            className={'flex-1'}
                            optionsClassName={'max-h-40'}
                            placeholder={'Pilih parent'}
                            options={options}
                            searchable
                            value={dataCategory?.parent}
                            onChange={onChangeForm}
                            onSearch={(keyword) => onSearchOptions(keyword)}
                        />
                        <InlineError className='mt-2' message={errorForm?.parent_id} />
                    </div>
                )}
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Category Name</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama kategori'}
                        value={dataCategory?.name}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.name} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>Category Slug</div>
                    <Input
                        className={'flex-1'}
                        name={'slug'}
                        placeholder={'Masukkan slug kategori'}
                        value={dataCategory?.slug}
                        pattern={/[a-z0-9\-]+$/}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.slug} />
                </div>
            </div>
        </ModalForm>
    )
}
